import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import { Injectable } from '@angular/core';
import {
    IDatiqGraph,
    IDatiqGraphSeries
} from '../models';
import { DatiqAmcharts5AxisUtilsService } from './datiq-amcharts-5-axis-utils.service';
import { DatiqAmCharts5SeriesCandlestickBuilder } from './datiq-amcharts-5-series-candlestick.builder';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5SeriesCandlestickService {
    constructor(private _utils: DatiqAmcharts5AxisUtilsService) {}

    create(
        root: am5.Root,
        chart: am5xy.XYChart,
        seriesData: IDatiqGraphSeries,
        settings: IDatiqGraph
    ): am5xy.XYChart {
        const candlestickSeries: am5xy.CandlestickSeries = chart?.series.push(
            am5xy.CandlestickSeries.new(root, {
                ...this.createInitialCandlestickSettings(seriesData, chart),
            })
        );
        this.createCandlestickSettings(
            candlestickSeries,
            seriesData,
            root
        ).setData(seriesData, candlestickSeries, chart);

        return chart;
    }

    createInitialCandlestickSettings(
        seriesData: IDatiqGraphSeries,
        chart: am5xy.XYChart
    ): am5xy.ICandlestickSeriesSettings {
        return {
            name: seriesData.id,
            xAxis: chart.xAxes.getIndex(seriesData?.xAxisIndex ?? 0),
            yAxis: chart.yAxes.getIndex(0),
            openValueYField: 'open',
            highValueYField: 'high',
            lowValueYField: 'low',
            valueYField: 'close',
            valueXField: 'x',
            categoryXField: 'x',
            clustered: false,
        };
    }

    createCandlestickSettings(
        series: am5xy.CandlestickSeries,
        seriesData: IDatiqGraphSeries,
        root: am5.Root
    ): this {
        new DatiqAmCharts5SeriesCandlestickBuilder()
            .addTopLine(series, seriesData, root)
            .addBottomLine(series, seriesData, root)
            .setColor(series, seriesData)
            .setWidth(series);
        return this;
    }

    private setData(
        seriesData: IDatiqGraphSeries,
        series: am5xy.CandlestickSeries,
        chart: am5xy.XYChart
    ) {
        const data = seriesData.data.map((dataPoint) => {
            return {
                open: dataPoint.open,
                high: dataPoint.high,
                low: dataPoint.low,
                close: dataPoint.close,
                y: dataPoint.y,
                x: this._utils.mapDataValue(dataPoint.x),
            };
        });
        series.data.setAll(data);
        chart.xAxes.getIndex(seriesData?.xAxisIndex ?? 0).data.setAll(data);
        return this;
    }
}
